import type { SxProps, Theme } from '@mui/material';

export const DASHBOARD_PAGE_SX: SxProps<Theme> = {
  px: { xs: 2, md: 1.5 },
};

export const DASHBOARD_FILTERS_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(220px, 0.8fr) minmax(520px, 1.8fr) minmax(260px, 1fr)',
  },
  alignItems: 'start',
  gap: 2,
  mt: 2,
  mb: 4,
};

export const BT_DASHBOARD_FILTERS_SX: SxProps<Theme> = {
  ...DASHBOARD_FILTERS_SX,
  gridTemplateColumns: { xs: '1fr', md: 'minmax(220px, 0.8fr) minmax(260px, 1fr)' },
  justifyContent: 'start',
};

export const FILTER_STEP_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
  minWidth: 0,
};

export const FILTER_STEP_AVATAR_SX: SxProps<Theme> = {
  width: 40,
  height: 40,
  bgcolor: '#a8aaac',
  fontSize: 20,
};

export const FILTER_STEP_CONTENT_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

export const TIME_FILTER_CONTENT_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateRows: 'auto auto',
  gap: 1.5,
  flex: 1,
  minWidth: 0,
};

export const TIME_RANGE_RADIO_SX: SxProps<Theme> = {
  py: 0.25,
  '& .MuiRadioGroup-root': { justifyContent: 'space-between', flexWrap: 'nowrap' },
  '& .MuiFormControlLabel-root': { marginInlineEnd: 0 },
  '& .MuiFormControlLabel-label': { fontSize: 13, whiteSpace: 'nowrap' },
};

export const DATE_FIELDS_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: 1.5,
};

export const GOAL_TARGET_FIELDS_SX: SxProps<Theme> = {
  display: 'grid',
  gap: 1.5,
  flex: 1,
  minWidth: 0,
};

export const DURATION_CONTROL_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: { xs: '100%', sm: 360 },
  gap: 1,
  gridColumn: '1 / -1',
};

export const REPORT_GRID_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 877px) minmax(340px, 424px)' },
  justifyContent: 'space-between',
  alignItems: 'stretch',
  gap: 1.75,
  flexGrow: 1,
};

export const CHART_AREA_SX: SxProps<Theme> = {
  width: '100%',
  minWidth: 0,
  height: { xs: 420, md: 560 },
};

export const DETAIL_AREA_SX: SxProps<Theme> = {
  width: '100%',
  minWidth: 0,
};

export const LOWER_AREA_SX: SxProps<Theme> = {
  gridColumn: { xs: '1', lg: '1 / -1' },
  minWidth: 0,
};
